import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import CreateTableComponent from "../../share/CreateTableComponent";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


export function Report56NewComponent() {

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re56data, setRe56data] = useState([]);

    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNewn BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }

    async function getR56() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res56 = await fetch("/api/Support/getR56", {
            method: 'POST',
            body: formData
        })
        const Re56data = await res56.json()
        setRe56data(Re56data.dataenum);
        console.log(Re56data)
    }

    const [Re56yeardata, setRe56yeardata] = React.useState([]);

    async function getR56year() {
        const res = await fetch("/api/Support/getyear56")
        const Re56yeardata = await res.json()
        setRe56yeardata(Re56yeardata.dataenum)
        console.log(Re56yeardata)
    }


    const y2 = Re56yeardata.filter(n => n.yearTh >= othYearSelected);
    const tableHeaders = y2.map((item, i) => (
        <>
            <th key={`header-${i}-1`} className='text-center'>
                แห่ง
            </th>
            <th key={`header-${i}-2`} className='text-center'>
                คน
            </th>
            <th key={`header-${i}-3`} className='text-center'>
                (บาท)
            </th>
        </>
    ));


    useEffect(() => {
        getR56()
        getR56year()
    }, [thYearSelected, othYearSelected])

    const tableHeaders2 = Re56data.map(n => n.count1);
    // console.log(tableHeaders2);

    var hidecolumn = (tableHeaders2.every(n => n >= 1)) ? false : true;
    var hidecolumn1 = (tableHeaders2.every(n => n >= 2)) ? false : true;
    var hidecolumn2 = (tableHeaders2.every(n => n >= 3)) ? false : true;
    var hidecolumn3 = (tableHeaders2.every(n => n >= 4)) ? false : true;
    var hidecolumn4 = (tableHeaders2.every(n => n >= 5)) ? false : true;
    var hidecolumn5 = (tableHeaders2.every(n => n >= 6)) ? false : true;
    var hidecolumn6 = (tableHeaders2.every(n => n >= 7)) ? false : true;
    var hidecolumn7 = (tableHeaders2.every(n => n >= 8)) ? false : true;

    var col = (((thYearSelected - othYearSelected) + 1) * 3);

    var col1 = ((col * 9) + 35);
    //var hidecolumn = false;
    //var hidecolumn1 = false;
    //var hidecolumn2 = false;
    //var hidecolumn3 = false;
    //var hidecolumn4 = false;
    //var hidecolumn5 = false;
    //var hidecolumn6 = false;
    //var hidecolumn7 = false;


    //if (othYearSelected > 2559 || thYearSelected < 2559) {
    //    var hidecolumn = true;
    //}
    //if (othYearSelected > 2560 || thYearSelected < 2560) {
    //    var hidecolumn1 = true;
    //}
    //if (othYearSelected > 2561 || thYearSelected < 2561) {
    //    var hidecolumn2 = true;
    //}
    //if (othYearSelected > 2562 || thYearSelected < 2562) {
    //    var hidecolumn3 = true;
    //}
    //if (othYearSelected > 2563 || thYearSelected < 2563) {
    //    var hidecolumn4 = true;
    //}
    //if (othYearSelected > 2564 || thYearSelected < 2564) {
    //    var hidecolumn5 = true;
    //}
    //if (othYearSelected > 2565 || thYearSelected < 2565) {
    //    var hidecolumn6 = true;
    //}
    //if (othYearSelected > 2566 || thYearSelected < 2566) {
    //    var hidecolumn7 = true;
    //}



   

    const [openModalForm, setOpenModalForm] = useState(false);
    const [Re56detail, setRe56detail] = useState([]);
    const [status, setStatus] = useState("13");
    const [R56detailfilter, setR56detailfilter] = useState([]);

    async function getR56detail(value, type) {
        const formData = new FormData();
        // console.log("thYearSelected",typeof thYearSelected);
        formData.append("thYear", thYearSelected);
        formData.append("status", String(type));
        // console.log("status",status);
        console.log("value", value);
        console.log("type", type);
        const res61 = await fetch("/api/Support/getR56detail", {
            method: 'POST',
            body: formData
        })
        const Re56data = await res61.json()
        // setRe61detail(Re61data.dataenum);
        setR56detailfilter(Re56data.dataenum.filter(
            (item) => item.abbr === value
        ))
        console.log(Re56data);
        modalToggleExtendCourse();
    }

    const modalToggleExtendCourse = () => {
        // getR55detail()
        setOpenModalForm(!openModalForm);
        // console.log("idmodal", value);
    }

    const COLUMNSTRAIN = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน",
            accessor: "supportName",
        },
        {
            Header: "เลขที่คำขอ",
            accessor: "supportNo",
        },
        {
            Header: "จำนวนคน",
            accessor: "personTotal",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },
        {
            Header: "จำนวนเงินที่จ่ายเงินอุดหนุนแล้ว (บาท)",
            accessor: "amount",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },

    ]

    return (
        <Container>
            <div>
                <div style={{ display: 'flex', paddingBottom: '20px' }}>
                    <h3 className='text-center' style={{ lineHeight: 'inherit' }}>
                        ปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            setOThYearSelected(e.target.value)
                        }}
                    >
                        {Re56yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                    <h3 style={{ lineHeight: 'inherit' }}>ถึง</h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div>
                <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/Support/xlsxR56?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>EXCEL</Button>
                        <Button className="btn1" href={`api/SupportReports/excelR56detail?thYear=${thYearSelected}&status=${status}&othYear=${othYearSelected}`} download>EXCEL(Detail)</Button>
                        <Button className="btn2" href={`api/Support/pdfR56?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>PDF</Button>
                    </Col>
                </Row>
                <div className="outer-wrapper">
                    <div className="table-wrapper">
                        <Table className="styled-table" bordered striped hover>
                            <thead>
                                <tr>
                                    <th rowSpan="3">
                                        ที่
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        หน่วยงาน
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        ผู้ดำเนินการทดสอบฯ ที่มีผู้ผ่านการทดสอบ 100 คน (ประกาศข้อ 4)
                                    </th>
                                    <th colSpan="3" rowSpan="2" className=' text-center'>
                                        ผู้ดำเนินการทดสอบฯ ทดสอบฯให้แก่ผู้ที่กรมฯส่งไปทดสอบ (ประกาศข้อ 5)
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        ผู้ประกอบกิจการที่ส่งเงินสมทบเข้ากองทุนฯ (ประกาศข้อ 6)
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        ผู้ประกอบที่พัฒนาฝีมือแรงงาน เกินกว่าร้อยละ 70 (ประกาศข้อ 7)
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        ผู้ที่ได้รับการรับรองมาตรฐานฝีมือแรงงานของตน (ประกาศข้อ 8)
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        ผู้ประกอบกิจการจ่ายที่ค่าจ้างตามมาตรฐานฝีมือ (ประกาศข้อ 9)
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        ผู้ประกอบกิจการที่ฝึกอบรมลูกจ้างในหลักสูตรสร้างสรรค์นวัตกรรมหรือเทคโนโลยี (ประกาศข้อ 10)
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        ผู้ดำเนินการทดสอบฯ ที่ส่งค่าทดสอบเข้ากองทุน (ประกาศข้อ 11)
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        ศูนย์ประเมินฯ มาตรา 26/4(2) ที่ส่งค่าธรรมเนียมเข้ากองทุน (ประกาศข้อ 11)
                                    </th>
                                    <th colSpan={col} className=' text-center'>
                                        ศูนย์ประเมินความรู้ความสามารถกลาง (ประกาศข้อ 12)
                                    </th>
                                    <th colSpan="3" rowSpan="2" className=' text-center'>
                                        รวม
                                    </th>
                                </tr>
                                <tr>

                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}

                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}

                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}

                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}

                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}

                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}

                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}

                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}

                                    {y2.map((item, i) => (
                                        <th colSpan="3" className='text-center' >
                                            ปีงบประมาณ {item.yearTh}
                                        </th>

                                    ))}
                                    {/*<th colSpan="3" className='text-center'>*/}
                                    {/*    รวม*/}
                                    {/*</th>*/}
                                </tr>
                                <tr>

                                    {tableHeaders}
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>

                                    {tableHeaders}

                                    {tableHeaders}

                                    {tableHeaders}

                                    {tableHeaders}

                                    {tableHeaders}

                                    {tableHeaders}

                                    {tableHeaders}

                                    {tableHeaders}
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>

                                </tr>


                            </thead>
                            <tbody>
                                {Re56data.length > 0 && Re56data.map((item, i) => (
                                    <tr key={i}>
                                        <td className='text-center'>
                                            {i + 1}
                                        </td>
                                        <td className='text-start'>
                                            {item.abbr}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "0")
                                                }}>{Number(item.sum1)}</p>
                                            {/* {item.sum1} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum2}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum3}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "0")
                                                }}>{Number(item.sum4)}</p>
                                            {/* {item.sum4} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum5}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum6}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>

                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "0")
                                                }}>{Number(item.sum7)}</p>
                                            {/* {item.sum7} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum8}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum9}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "0")
                                                }}>{Number(item.sum10)}</p>
                                            {/* {item.sum10} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum11}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum12}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "0")
                                                }}>{Number(item.sum13)}</p>
                                            {/* {item.sum13} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum14}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum15}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "0")
                                                }}>{Number(item.sum16)}</p>
                                            {/* {item.sum16} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum17}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum18}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "0")
                                                }}>{Number(item.sum19)}</p>
                                            {/* {item.sum19} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum20}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum21}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "0")
                                                }}>{Number(item.sum22)}</p>
                                            {/* {item.sum22} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum23}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum24}
                                        </td>

                                        <td className='text-end'>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "1")
                                                }}>{Number(item.sum28)}</p>
                                            {/* {item.sum25} 1 */}
                                        </td>
                                        <td className='text-end'>
                                            {item.sum29}
                                        </td>
                                        <td className='text-end'>
                                            {item.sum30}
                                        </td>

                                        <td className='text-end' hidden={hidecolumn}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum31)}</p>
                                            {/* {item.sum31} 1 */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum32}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum33}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum34)}</p>
                                            {/* {item.sum34} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum35}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum36}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum37)}</p>
                                            {/* {item.sum37} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum38}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum39}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum40)}</p>
                                            {/* {item.sum40} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum41}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum42}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum43)}</p>
                                            {/* {item.sum43} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum44}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum45}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum46)}</p>
                                            {/* {item.sum46} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum47}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum48}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum49)}</p>
                                            {/* {item.sum49} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum50}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum51}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum52)}</p>
                                            {/* {item.sum52} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum53}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum54}
                                        </td>

                                        <td className='text-end' hidden={hidecolumn}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "4")
                                                }}>{Number(item.sum58)}</p>
                                            {/* {item.sum58} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum59}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum60}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "4")
                                                }}>{Number(item.sum61)}</p>
                                            {/* {item.sum61} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum62}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum63}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "4")
                                                }}>{Number(item.sum64)}</p>
                                            {/* {item.sum64} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum65}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum66}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "4")
                                                }}>{Number(item.sum67)}</p>
                                            {/* {item.sum67} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum68}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum69}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "4")
                                                }}>{Number(item.sum70)}</p>
                                            {/* {item.sum70} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum71}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum72}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "4")
                                                }}>{Number(item.sum73)}</p>
                                            {/* {item.sum73} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum74}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum75}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "4")
                                                }}>{Number(item.sum76)}</p>
                                            {/* {item.sum76} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum77}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum78}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "4")
                                                }}>{Number(item.sum79)}</p>
                                            {/* {item.sum79} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum80}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum81}
                                        </td>

                                        <td className='text-end' hidden={hidecolumn}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "5")
                                                }}>{Number(item.sum85)}</p>
                                            {/* {item.sum85} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum86}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum87}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "5")
                                                }}>{Number(item.sum88)}</p>
                                            {/* {item.sum88} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum89}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum90}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "5")
                                                }}>{Number(item.sum91)}</p>
                                            {/* {item.sum91} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum92}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum93}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "5")
                                                }}>{Number(item.sum94)}</p>
                                            {/* {item.sum94} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum95}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum96}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "5")
                                                }}>{Number(item.sum97)}</p>
                                            {/* {item.sum97} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum98}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum99}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "5")
                                                }}>{Number(item.sum100)}</p>
                                            {/* {item.sum100} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum101}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum102}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "5")
                                                }}>{Number(item.sum103)}</p>
                                            {/* {item.sum103} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum104}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum105}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "5")
                                                }}>{Number(item.sum106)}</p>
                                            {/* {item.sum106} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum107}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum108}
                                        </td>

                                        <td className='text-end' hidden={hidecolumn}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "6")
                                                }}>{Number(item.sum112)}</p>
                                            {/* {item.sum112} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum113}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum114}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "6")
                                                }}>{Number(item.sum115)}</p>
                                            {item.sum115}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum116}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum117}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2} >
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "6")
                                                }}>{Number(item.sum118)}</p>
                                            {/* {item.sum118} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum119}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum120}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "6")
                                                }}>{Number(item.sum121)}</p>
                                            {/* {item.sum121} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum122}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum123}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "6")
                                                }}>{Number(item.sum124)}</p>
                                            {/* {item.sum124} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum125}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum126}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "6")
                                                }}>{Number(item.sum127)}</p>
                                            {/* {item.sum127} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum128}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum129}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "6")
                                                }}>{Number(item.sum130)}</p>
                                            {/* {item.sum130} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum131}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum132}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "6")
                                                }}>{Number(item.sum133)}</p>
                                            {/* {item.sum133} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum134}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum135}
                                        </td>

                                        <td className='text-end' hidden={hidecolumn}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "7")
                                                }}>{Number(item.sum139)}</p>
                                            {/* {item.sum139} 1 */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum140}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum141}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "7")
                                                }}>{Number(item.sum142)}</p>
                                            {/* {item.sum142} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum143}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum144}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "7")
                                                }}>{Number(item.sum145)}</p>
                                            {/* {item.sum145} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum146}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum147}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "7")
                                                }}>{Number(item.sum148)}</p>
                                            {/* {item.sum148} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum149}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum150}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "7")
                                                }}>{Number(item.sum151)}</p>
                                            {/* {item.sum151} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum152}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum153}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "7")
                                                }}>{Number(item.sum154)}</p>
                                            {/* {item.sum154} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum155}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum156}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "7")
                                                }}>{Number(item.sum157)}</p>
                                            {/* {item.sum157} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum158}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum159}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "7")
                                                }}>{Number(item.sum160)}</p>
                                            {/* {item.sum160} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum161}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum162}
                                        </td>

                                        <td className='text-end' hidden={hidecolumn}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum166)}</p>
                                            {/* {item.sum166} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum167}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum168}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum169)}</p>
                                            {/* {item.sum169} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum170}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum171}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum172)}</p>
                                            {/* {item.sum172} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum173}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum174}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum175)}</p>
                                            {/* {item.sum175} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum176}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum177}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum178)}</p>
                                            {/* {item.sum178} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum179}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum180}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum181)}</p>
                                            {/* {item.sum181} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum182}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum183}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum184)}</p>
                                            {/* {item.sum184} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum185}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum186}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "3")
                                                }}>{Number(item.sum187)}</p>
                                            {/* {item.sum187} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum188}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum189}
                                        </td>

                                        <td className='text-end' hidden={hidecolumn}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "8")
                                                }}>{Number(item.sum193)}</p>
                                            {/* {item.sum193} 1 */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum194}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum195}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "8")
                                                }}>{Number(item.sum196)}</p>
                                            {/* {item.sum196} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum197}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum198}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "8")
                                                }}>{Number(item.sum199)}</p>
                                            {/* {item.sum199} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum200}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum201}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "8")
                                                }}>{Number(item.sum202)}</p>
                                            {/* {item.sum202} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum203}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum204}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "8")
                                                }}>{Number(item.sum205)}</p>
                                            {/* {item.sum205} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum206}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum207}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "8")
                                                }}>{Number(item.sum208)}</p>
                                            {/* {item.sum208} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum209}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum210}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "8")
                                                }}>{Number(item.sum211)}</p>
                                            {/* {item.sum211} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum212}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum213}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "8")
                                                }}>{Number(item.sum214)}</p>
                                            {/* {item.sum214} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum215}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum216}
                                        </td>

                                        {/*</td>*/}
                                        <td className='text-end' hidden={hidecolumn}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "9")
                                                }}>{Number(item.sum220)}</p>
                                            {/* {item.sum220} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum221}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn}>
                                            {item.sum222}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "9")
                                                }}>{Number(item.sum223)}</p>
                                            {/* {item.sum223} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum224}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn1}>
                                            {item.sum225}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "9")
                                                }}>{Number(item.sum226)}</p>
                                            {/* {item.sum226} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum227}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn2}>
                                            {item.sum228}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "9")
                                                }}>{Number(item.sum229)}</p>
                                            {/* {item.sum229} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum230}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn3}>
                                            {item.sum231}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "9")
                                                }}>{Number(item.sum232)}</p>
                                            {/* {item.sum232} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum233}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn4}>
                                            {item.sum234}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "9")
                                                }}>{Number(item.sum235)}</p>
                                            {/* {item.sum235} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum236}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn5}>
                                            {item.sum237}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "9")
                                                }}>{Number(item.sum238)}</p>
                                            {/* {item.sum238} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum239}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn6}>
                                            {item.sum240}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "9")
                                                }}>{Number(item.sum241)}</p>
                                            {/* {item.sum241} */}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum242}
                                        </td>
                                        <td className='text-end' hidden={hidecolumn7}>
                                            {item.sum243}
                                        </td>

                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.abbr}
                                                onClick={(e) => {
                                                    getR56detail(e.target.id, "11")
                                                }}>{Number(item.sum247)}</p>
                                            {/* {item.sum247} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.sum248}
                                        </td>
                                        <td className='text-end'>
                                            {item.sum249}
                                        </td>


                                    </tr>

                                )) || <tr><td colSpan={col1} rowSpan="6" className='text-center'>No Data</td></tr>}



                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            <Modal

                isOpen={openModalForm}
                toggle={modalToggleExtendCourse}
                // style={{ maxWidth: "600px", width: "100%" }}
                centered
                scrollable
                backdrop={'static'}
                keyboard={false}
                size="xl"

                className="modal-bordered"
            >
                <ModalHeader toggle={modalToggleExtendCourse} className="styled-modal text-center">
                    รายละเอียดข้อมูล
                </ModalHeader>
                <ModalBody >
                    <CreateTableComponent column={COLUMNSTRAIN} dataInput={R56detailfilter} showEntrie={true} showPage={true} />
                </ModalBody>
            </Modal>

        </Container>


    )
}